import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { HalfCircleSpinner } from 'react-epic-spinners';
import { Scrollbar } from "react-scrollbars-custom";
import { base_url } from '../Api/Api';
import { Loader } from '../Common/Loader';
import { Warning } from '../Common/Warning';
import { Fragment } from 'react';
import EntrnaceHeader from './EntranceHeader';

const Addshop = (props) => {

    const [province, setProvince] = useState([]); // province options
    const [City, setCity] = useState([]); // City options
    const [shop, setShop] = useState([]); // shop options
    const [details, setDetails] = useState({
        show: false,
        loading: false,
        errorValid: false,
        errorCity: false,
        noContent: true,
        noContentCity: true,
        loaderApi: false
    });
    const [inputValue, setInputValue] = useState({
        phone: '',
        codePostal: '',
        address: '',
        nameShop: ''
    });
    const [state, setState] = useState({
        selectedProvince: '',
        selectedCity: '',
        selectedShop: '',
        storeType: '',
    })

    useEffect(() => {

        setTimeout(() => {
            setDetails({
                ...details,
                loading: true
            })
        }, 300);

        // setProvince

        base_url.get("getProvinces")
            .then(response => {
                setProvince(response.data.provinces)
            })

        // setStoreType
        base_url.get("storeTypes")
            .then(response => {
                setShop(response.data.storeTypes)
                setState({
                    ...state,
                    shopActvie: false
                })
            })

    }, [])

    const getCity = (id) => {

        setCity([])
        // set Citys

        base_url.get(`cities/${id}`)
            .then(response => {
                setCity(response.data.cities)
                setDetails({
                    ...details,
                    noContent: false
                })
            })

    }

    const handleInputValue = (e, target) => {
        setInputValue({
            ...inputValue,
            [target]: e.target.value
        })
    }

    const handleChange = (info, target) => {
        if (target == 'selectedProvince') {
            setState({
                ...state,
                [target]: info,
                selectedCity: '',
                selectedShop: ''
            })
            document.getElementById('provinceValue').innerHTML = info.name
            document.getElementById('cityValue').innerHTML = null
            document.getElementById('shopValue').innerHTML = null
            getCity(info.id)
        } else if (target == 'selectedCity') {
            setState({
                ...state,
                [target]: info,
                selectedShop: ''
            })
            document.getElementById('cityValue').innerHTML = info.name
            document.getElementById('shopValue').innerHTML = null
        } else if (target == 'selectedShop') {
            setState({
                ...state,
                [target]: info
            })
            document.getElementById('shopValue').innerHTML = info.title
        }
    }

    const contniue = () => {

        const data = {
            'mobile': JSON.parse(localStorage.getItem('phoneNumber')),
            'city_id': state.selectedCity.id,
            'phone': inputValue.phone,
            'postal_code': inputValue.codePostal,
            'address': inputValue.address,
            'name': inputValue.nameShop,
            'store_type': state.selectedShop.id
        }
        if (state.selectedCity.length !== 0 &&
            inputValue.phone.length == 11 &&
            inputValue.codePostal.length == 10 &&
            inputValue.address.length !== 0 &&
            inputValue.nameShop.length !== 0 &&
            state.selectedShop.length !== 0) {

            // localStorage.setItem('shopInfo', JSON.stringify(data));
            setDetails({
                ...details,
                loaderApi: true
            })
            
            base_url.post(`addStore`, data)
                .then(response => {
                    setDetails({
                        ...details,
                        loaderApi: false
                    })
                    props.history.push('/entrance/step4')
                })
                .catch(error => {
                    setDetails({
                        ...details,
                        loaderApi: false
                    })
                    props.history.push('/entrance/step4')
                })

        } else {
            setDetails({
                ...details,
                errorValid: true
            })
        }
    }

    return (
        <Fragment>
            <EntrnaceHeader />
            <div className={`entrnc-web shop-info set-shop ${details.loading ? 'active' : ''}`}>
                <Loader
                    active={false} />

                {/* <div className="header_menu">
                <div className="header contain ">
                    <i className="icon-Group-4044"></i>
                    <span>Samsung Plus</span>
                </div>
            </div> */}


                <div className="bx-info">
                    <Scrollbar>
                        <div className="inner-scrolbar select-input">

                            <div className="titles-style-1">
                                <h4>افزودن فروشگاه</h4>
                            </div>
                            <div className={`input-form`} >

                                <FormControl>
                                    <InputLabel id="province">استان</InputLabel>
                                    <i className="icon-arrow-down-sign-to-navigate"></i>
                                    <Select
                                        labelId="province"
                                        id="provinceValue"
                                        value={state.selectedProvince} >

                                        <Scrollbar className={`entrance-web 
                                    ${province.length >= 10 ? 'normal' :
                                                province.length >= 5 ? 'min' : 'zero'}`}>

                                            {province.length == 0 ?
                                                details.noContent ?
                                                    <div className="loader-item">
                                                        <HalfCircleSpinner
                                                            size={35}
                                                            color="#1e1e1e" />
                                                    </div>
                                                    :
                                                    <span className="no-info">موردی برای نمایش وجود ندارد</span>
                                                :
                                                province.map(info =>
                                                    <MenuItem
                                                        key={info.id}
                                                        onClick={() => handleChange(info, 'selectedProvince')} >
                                                        {info.name}
                                                    </MenuItem>
                                                )
                                            }
                                        </Scrollbar>

                                    </Select>
                                </FormControl>

                                <span className={`error-respns ${details.errorValid && state.selectedProvince.length == 0 ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                                استان خود را انتخاب کنید
                            </span>
                            </div>
                            <div className={`input-form`}>

                                <FormControl
                                    disabled={state.selectedProvince.length == 0} >
                                    <InputLabel id="city">شهر</InputLabel>
                                    <i className="icon-arrow-down-sign-to-navigate"></i>
                                    <Select
                                        labelId="city"
                                        id="cityValue"
                                        value={state.selectedCity} >

                                        <Scrollbar className={`entrance-web 
                                    ${City.length >= 10 ? 'normal' :
                                                City.length >= 5 ? 'min' : 'zero'}`}>

                                            {City.length == 0 ?
                                                details.noContentCity ?
                                                    <div className="loader-item">
                                                        <HalfCircleSpinner
                                                            size={35}
                                                            color="#1e1e1e" />
                                                    </div>
                                                    :
                                                    <span className="no-info">موردی برای نمایش وجود ندارد</span>
                                                :
                                                City.map(info =>
                                                    <MenuItem
                                                        key={info.id}
                                                        onClick={() => handleChange(info, 'selectedCity')} >
                                                        {info.name}
                                                    </MenuItem>
                                                )
                                            }
                                        </Scrollbar>

                                    </Select>
                                </FormControl>

                                <span className={`error-respns ${details.errorValid && state.selectedCity.length == 0 ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                                شهر خود را انتخاب کنید
                            </span>
                            </div>
                            <div className="input-form">
                                <TextField
                                    id="standard-basic"
                                    label="تلفن ثابت *"
                                    onChange={(e) => handleInputValue(e, 'phone')}
                                    onInput={(e) => {
                                        if (!(/^\d+$/).test(e.target.value)) {
                                            e.target.value = e.target.value = e.target.value.slice(0, e.target.value.length - 1)
                                        }
                                        e.target.value = e.target.value.slice(0, 11)
                                    }} />
                                <span className={`error-respns ${details.errorValid && inputValue.phone.length < 11 ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                        تلفن ثابت را بصورت صحیح  و کامل وارد کنید
                    </span>
                            </div>
                            <div className="input-form">
                                <TextField
                                    id="standard-basic"
                                    label="کد پستی *"
                                    onChange={(e) => handleInputValue(e, 'codePostal')}
                                    onInput={(e) => {
                                        if (!(/^\d+$/).test(e.target.value)) {
                                            e.target.value = e.target.value = e.target.value.slice(0, e.target.value.length - 1)
                                        }
                                        e.target.value = e.target.value.slice(0, 10)
                                    }} />
                                <span className={`error-respns ${details.errorValid && inputValue.codePostal.length < 10 ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                        کد پستی را بصورت صحیح  و کامل وارد کنید
                    </span>
                            </div>
                            <div className="input-form">
                                <TextField
                                    id="standard-basic"
                                    label="نام فروشگاه *"
                                    onChange={(e) => handleInputValue(e, 'nameShop')} />
                                <span className={`error-respns ${details.errorValid && inputValue.nameShop.length == 0 ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                        نام فروشگاه خود را وارد کنید
                    </span>
                            </div>
                            <div className={`input-form`} >

                                <FormControl
                                    disabled={state.selectedCity.length == 0}>
                                    <InputLabel id="shop">نوع فروشگاه</InputLabel>
                                    <i className="icon-arrow-down-sign-to-navigate"></i>
                                    <Select
                                        labelId="shop"
                                        id="shopValue"
                                        value={state.selectedShop}>

                                        <Scrollbar className={`entrance-web 
                                    ${shop.length >= 3 ? 'normal' : 'zero'}`}>

                                            <FormControl
                                                component="fieldset"
                                                className="radio-bnts">
                                                <RadioGroup
                                                    aria-label="stores"
                                                    name="stores"
                                                    value={state.selectedShop.id} >
                                                    {shop.length == 0 ?
                                                        <span className="no-info store">
                                                            <i className="icon-store"></i>
                                                    موردی برای نمایش وجود ندارد
                                                </span>
                                                        :
                                                        shop.map((info, index) =>
                                                            <div className="radio-btn">
                                                                <FormControlLabel
                                                                    key={info.id}
                                                                    value={info.id}
                                                                    control={<Radio />}
                                                                    label={info.title}
                                                                    onClick={() => handleChange(info, 'selectedShop')} />
                                                                <p>{info.description}</p>
                                                            </div>
                                                        )}
                                                </RadioGroup>
                                            </FormControl>

                                        </Scrollbar>

                                    </Select>
                                </FormControl>

                                <span className={`error-respns ${details.errorValid && state.selectedShop.length == 0 ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                                نوع فروشگاه خود را انتخاب کنید
                            </span>
                            </div>
                            <div className="input-form address">
                                <TextField
                                    id="standard-basic"
                                    label="آدرس *"
                                    onChange={(e) => handleInputValue(e, 'address')} />
                                <span className={`error-respns ${details.errorValid && inputValue.address.length == 0 ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                        آدرس خود را وارد کنید
                    </span>
                            </div>
                            <div className="btn-base btn-black btn-sircle">
                                <Button
                                    variant="contained"
                                    onClick={() => props.history.goBack()}>بازگشت</Button>
                                <Button
                                    variant="contained"
                                    onClick={contniue}>ثبت</Button>
                            </div>

                        </div>
                    </Scrollbar>

                </div>

            </div >
        </Fragment>
    );
}

export default Addshop;